module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Fortaleciendo Los Cimientos")]), _vm._v(" "), _c('h1', [_vm._v("Stephanie Albright")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Traducido por mislibrosencastellano ")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-f"
  }, [_vm._v("“F")]), _vm._v("ortaleciendo Los Cimientos”")])]), _vm._v(" "), _c('p', [_vm._v("Escrito por Stephanie Albright")]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2022 Stephanie Albright")]), _vm._v(" "), _c('p', [_vm._v("Todos los derechos reservados")]), _vm._v(" "), _c('p', [_vm._v("Distribuido por Babelcube, Inc. ")]), _vm._v(" "), _c('p', [_vm._v("www.babelcube.com ")]), _vm._v(" "), _c('p', [_vm._v("Traducido por mislibrosencastellano")]), _vm._v(" "), _c('p', [_vm._v("“Babelcube Books” y “Babelcube” son marcas registradas de Babelcube Inc.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "xx-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Fortaleciendo Los Cimientos")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "xx-large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Pulso – Electromagnético PEM")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "xx-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Stephanie Albright")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Esta es una obra de ficción. Cualquier parecido con personas reales, vivas o muertas, o eventos reales es pura coincidencia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "page-break-before": "always",
      "text-align": "right"
    }
  }, [_vm._v("¡A mis lectores! Nunca podré agradecerles lo suficiente. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f13440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c001.vue
// module id = 60
// module chunks = 0